export function salesRepEmail(salesRep: string): string | undefined {
  const atIndex = salesRep.indexOf("@");
  return atIndex > 0 && atIndex < salesRep.length - 1 ? salesRep : undefined;
}

export function salesRepDisplayName(salesRep: string): string {
  const email = salesRepEmail(salesRep);
  if (!email) {
    return salesRep;
  }

  const localPart = email.slice(0, email.indexOf("@"));
  const nameParts = localPart.split(".").filter((part) => part.length > 0);
  if (nameParts.length === 0) {
    return salesRep;
  }

  return nameParts.map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1).toLowerCase()}`).join(" ");
}
